import React from "react";
import { Routes, Route } from "react-router-dom";
import { useAuth } from "../auth/authContext";
import Login from "../components/login";
import ProtectedRoute from "./protectedRoutes";
import SetPassword from "../components/setPassword";
import { flattenNavItems } from "../navigation/navDataUtils";

function normalizeRouteKey(value) {
  return String(value || "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toLowerCase();
}

const componentLoaders = {
  [normalizeRouteKey("Dashboard")]: () => require("../components/dashboard").default,
  [normalizeRouteKey("Arrival List")]: () =>
    require("../components/arrivalsList").default,
  [normalizeRouteKey("Booking List")]: () =>
    require("../components/bookingList").default,
  [normalizeRouteKey("Daily Transaction")]: () =>
    require("../components/dailyTransaction").default,
  [normalizeRouteKey("User Management")]: () => require("../components/user").default,
  [normalizeRouteKey("FAQ Management")]: () => require("../components/faq").default,
  [normalizeRouteKey("Trip Listing")]: () =>
    require("../components/tripListing").default,
  [normalizeRouteKey("News Room")]: () => require("../components/newsRoom").default,
  [normalizeRouteKey("Subscription")]: () =>
    require("../components/subscription").default,
  [normalizeRouteKey("Slice and Dice")]: () =>
    require("../components/sliceAndDice").default,
  [normalizeRouteKey("Privacy and Policy")]: () =>
    require("../components/privacyAndPolicy").default,
  [normalizeRouteKey("Terms and Condition")]: () =>
    require("../components/termsAndCondition").default,
  [normalizeRouteKey("Flodesk")]: () => require("../components/floDesk").default,
  [normalizeRouteKey("Role Management")]: () =>
    require("../components/roleManagement").default,
  [normalizeRouteKey("Category")]: () =>
    require("../components/categoryManagement").default,
  [normalizeRouteKey("Featured Deals")]: () =>
    require("../components/featuredHotels").default,
  [normalizeRouteKey("Hotel Deals")]: () =>
    require("../components/featuredHotels").default,
  [normalizeRouteKey("Deals")]: () => require("../components/deals").default,
  [normalizeRouteKey("Coach Management")]: () =>
    require("../components/coachManagement").default,
  [normalizeRouteKey("Coach Assignment")]: () =>
    require("../components/coachAssignment").default,
  [normalizeRouteKey("Fuel Your Race Management")]: () =>
    require("../components/fuelYourRaceManagement").default,
  [normalizeRouteKey("Training Essentials")]: () =>
    require("../components/trainingEssentialsManagement").default,
  [normalizeRouteKey("Race Creation")]: () =>
    require("../components/raceManagement").default,
  [normalizeRouteKey("Race Cations")]: () =>
    require("../components/raceManagement").default,
  [normalizeRouteKey("Affiliates")]: () => require("../components/affiliates").default,
  [normalizeRouteKey("Market")]: () => require("../components/market").default,
  [normalizeRouteKey("Tags")]: () => require("../components/tagManagement").default,
  [normalizeRouteKey("Ship Tool")]: () =>
    require("../components/shopTool").default,
  [normalizeRouteKey("Shop Tool")]: () =>
    require("../components/shopTool").default,
  [normalizeRouteKey("Hotel Search")]: () =>
    require("../components/shopTool").default,
  [normalizeRouteKey("About Us")]: () => require("../components/aboutUs").default,
  [normalizeRouteKey("Purchase Orders")]: () =>
    require("../components/purchaseOrders").default,
};

function RouteComponentRenderer({ componentKey }) {
  const loadComponent = componentLoaders[componentKey];
  if (!loadComponent) {
    return null;
  }

  const Component = loadComponent();
  return <Component />;
}

const AppRouter = () => {
  const { navData } = useAuth();

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/set-password" element={<SetPassword />} />

      <Route element={<ProtectedRoute navData={navData} />}>
        <Route
          path="/deals/add"
          element={React.createElement(require("../components/dealForm").default)}
        />
        <Route
          path="/deals/edit/:id"
          element={React.createElement(require("../components/dealForm").default)}
        />
        <Route
          path="/feature-deals/add"
          element={React.createElement(require("../components/featureDealsForm").default)}
        />
        <Route
          path="/feature-deals/edit/:id"
          element={React.createElement(require("../components/featureDealsForm").default)}
        />
        <Route
          path="/coach-management/add"
          element={React.createElement(require("../components/coachForm").default)}
        />
        <Route
          path="/coach-management/edit/:id"
          element={React.createElement(require("../components/coachForm").default)}
        />
        <Route
          path="/fuel-your-race-management/add"
          element={React.createElement(require("../components/fuelYourRaceForm").default)}
        />
        <Route
          path="/fuel-your-race-management/edit/:id"
          element={React.createElement(require("../components/fuelYourRaceForm").default)}
        />
        <Route
          path="/training-essentials/add"
          element={React.createElement(require("../components/trainingEssentialsForm").default)}
        />
        <Route
          path="/training-essentials/edit/:id"
          element={React.createElement(require("../components/trainingEssentialsForm").default)}
        />
        <Route
          path="/race-management/add"
          element={React.createElement(require("../components/raceForm").default)}
        />
        <Route
          path="/race-management/edit/:id"
          element={React.createElement(require("../components/raceForm").default)}
        />
        <Route
          path="/race-management/:id/purchases"
          element={React.createElement(require("../components/racePurchases").default)}
        />
        <Route
          path="/race-form"
          element={React.createElement(require("../components/raceForm").default)}
        />
        <Route
          path="/race-form/:id"
          element={React.createElement(require("../components/raceForm").default)}
        />
        {flattenNavItems(navData).map((navItem) => {
          const componentKey = normalizeRouteKey(navItem.text);
          if (!componentLoaders[componentKey]) {
            return null;
          }

          return (
            <Route
              key={navItem.id}
              path={navItem.link}
              element={<RouteComponentRenderer componentKey={componentKey} />}
            />
          );
        })}
      </Route>

      <Route path="*" element={null} />
    </Routes>
  );
};

export default AppRouter;
